import moment from 'moment';

// Old, non-namespaced key (shared by every tenant/user in the browser). Now
// replaced by usePersistedFilters('financeiro.conciliacao'); removed on mount.
export var LEGACY_FILTER_STORAGE_KEY = 'bankReconciliation_filter';

export var BANK_RECONCILIATION_FILTERS_KEY = 'financeiro.conciliacao';

export var getDefaultBankReconciliationFilters = function() {
    return {
        from: moment().startOf('month').format('YYYY-MM-DD'),
        to: moment().endOf('month').format('YYYY-MM-DD'),
        activeView: 'pending',
        selectedBankId: null,
        search: '',
    };
};

// Applied filters -> loadBankStatements params. The imports view has no
// statement list, so it loads the pending statements (as the page always did).
export var toBankStatementsRequest = function(filters) {
    return {
        status: filters.activeView === 'imports' ? 'pending' : filters.activeView,
        from: filters.from,
        to: filters.to,
        bank_account_id: filters.selectedBankId || null,
        view: 'period',
    };
};

// True when from/to cover exactly one calendar month (1st to last day).
export var isSingleWholeMonth = function(from, to) {
    if (!from || !to) return false;
    var start = moment(from, 'YYYY-MM-DD');
    var end = moment(to, 'YYYY-MM-DD');
    return start.isSame(end, 'month') &&
        start.date() === 1 &&
        end.date() === end.daysInMonth();
};

export var getPeriodLabel = function(from, to) {
    if (isSingleWholeMonth(from, to)) {
        return 'Mês: ' + moment(from, 'YYYY-MM-DD').format('MMM/YYYY');
    }
    return moment(from, 'YYYY-MM-DD').format('DD/MM/YY') + ' - ' + moment(to, 'YYYY-MM-DD').format('DD/MM/YY');
};

export var isPeriodDefault = function(filters, defaults) {
    return filters.from === defaults.from && filters.to === defaults.to;
};

// Badge count: only what differs from the defaults (period counts as one).
export var countActiveFilters = function(filters, defaults) {
    return (isPeriodDefault(filters, defaults) ? 0 : 1) +
        (filters.activeView !== defaults.activeView ? 1 : 0) +
        (filters.selectedBankId ? 1 : 0) +
        (filters.search ? 1 : 0);
};
